import { GridCol, GridContainer, GridRow, Icon, ICONS } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { AssetProps } from '@websrc/App/Components/Asset/Asset'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { hasAsset } from '@websrc/App/Helpers/hasAsset'
import { spotWrapperProps } from '@websrc/App/Helpers/spotWrapperProps'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapQuoteSpot } from '@websrc/DataMappers/mapSpot'
import { SpotLinkAnchor } from '@websrc/Spot/Link/SpotLinkAnchor'
import React, { useContext } from 'react'

import { LearnMoreButtonType } from '../Collapse/SpotCollapse'
import * as SC from './SpotQuote.style'

export interface SpotQuoteProps {
  spot: ReturnType<typeof mapQuoteSpot>['quote']
  LearnMoreButton?: LearnMoreButtonType
  imageLazy?: boolean
}

export const SpotQuote = ({ LearnMoreButton, spot, imageLazy }: SpotQuoteProps) => {
  const { link, reversed_layout } = spot
  const { matomoPageTemplate } = useContext(AppProviderContext)

  const renderAsset = (asset: AssetProps | undefined) =>
    hasAsset(asset) && (
      <GridCol desktop={6}>
        <SC.QuoteAsset
          lazyLoading={imageLazy}
          sizes={`(min-width: 1024px) 600px`}
          srcSetWidths={[320, 400, 600, 800, 1200]}
          {...asset}
        />
      </GridCol>
    )

  return (
    <GridContainer {...spotWrapperProps(spot.caption)} data-testid={'caption'}>
      <GridRow>
        {reversed_layout && renderAsset(spot.asset)}
        <GridCol desktop={hasAsset(spot.asset) ? 6 : 12}>
          <SC.QuoteContent hasAsset={hasAsset(spot.asset)} reversedLayout={reversed_layout}>
            {spot.quote && (
              <SC.QuoteText hasAsset={hasAsset(spot.asset)}>
                <Markdown markdown={spot.quote} />
              </SC.QuoteText>
            )}
            {spot.quote_source && (
              <SC.QuoteSource>
                <Markdown markdown={spot.quote_source} />
              </SC.QuoteSource>
            )}
            {link.cta_text && (
              <SpotLinkAnchor
                ctaType={'tertiary'}
                link={link}
                onClick={() =>
                  matomo.trackEvent(
                    'engagement',
                    matomoPageTemplate,
                    [spot.caption ? spot.caption : 'quote'],
                    [link.cta_text],
                    'text'
                  )
                }
              >
                <Icon icon={ICONS.ARROW_RIGHT} size={16} />
                <span>{link.cta_text}</span>
              </SpotLinkAnchor>
            )}
            {LearnMoreButton && (
              <SC.LearnMoreButtonWrapper isSibling={Boolean(link)}>
                <LearnMoreButton />
              </SC.LearnMoreButtonWrapper>
            )}
          </SC.QuoteContent>
        </GridCol>
        {!reversed_layout && renderAsset(spot.asset)}
      </GridRow>
    </GridContainer>
  )
}
